import { Stack } from "@mui/material";
import { ReactElement } from "react";

import { StatusColor } from "./StatusLabel.style";

type Props = {
  color: string;
  label: string;
  id?: string;
  isUpperCase?: boolean;
};

const StatusLabel = ({
  id = "id_lbl_status",
  color,
  label,
  isUpperCase = true,
}: Props): ReactElement => {
  return (
    <Stack direction="row" spacing={2}>
      <div>
        <StatusColor color={color} />
      </div>
      <div id={id}>{isUpperCase ? label.toUpperCase() : label}</div>
    </Stack>
  );
};

export default StatusLabel;
